const API = {
  APP_SETTINGS_TIMEZONES: "/settings/timezones",
  SETTINGS_TENANT_COMPANY_INFO: "/Settings/tenant/companyInfo",
  SETTINGS_TENANT_PREFERENCES: "/Settings/tenant/preferences",
  SETTINGS_TENANT_USER_PREFERENCES: "/Settings/tenant/defaultUserPreferences",
  SETTINGS_TENANT_LOGO: "/Settings/tenant/logo",
  COMPANIES: "/Companies",
  COMPANIES_EQUIPMENT: "/Companies/Equipment",
  COMPANIES_CONTACTS: "/Companies/Contacts",
  COMPANIES_NOTES: "/Companies/Notes",
  COMPANIES_EQUIPMENT_NOTES: "/Companies/Equipment/Notes",
  ITEMS: "/Items",
  FILES: "/Files",
  FILES_THUMBNAIL: "/Files/{id}/thumbnail",
  FILES_PREVIEW: "/Files/{id}/preview",
  USERS: "/Users",
  VEHICLES: "/Vehicles",
  ESTIMATES: "/Estimates",
  ESTIMATES_CUSTOMER: "/Estimates/customer",
  ESTIMATES_PREVIEW: "/Estimates/preview",
  ESTIMATES_SEND: "/Estimates/send",
  NOTES: "Notes",
  NOTIFICATIONS: "Notifications",
  QUICKBOOKS_STATUS: "/QuickBooks/SyncStatus",
  QUICKBOOKS_STATUS_NEW: "/Features/tenant/QuickBooksIntegration/status",
  SUB_WORK_ORDERS: "/WorkOrders/SubWorkOrders",
  SUB_WORK_ORDER_CANCEL: "/WorkOrders/SubWorkOrders/Cancel",
  SUB_WORK_ORDER_EXPPENSES: "/WorkOrders/SubWorkOrders/Expenses",
  SUB_WORK_ORDER_RESCHEDULE: "/WorkOrders/SubWorkOrders/Reschedule",
  SUB_WORK_ORDER_CONTACTS: "/WorkOrders/SubWorkOrders/Contacts",
  SUB_WORK_ORDER_EQUIPMENT: "/WorkOrders/SubWorkOrders/Equipment",
  SUB_WORK_ORDER_EQUIPMENT_NOTES: "/WorkOrders/SubWorkOrders/Equipment/Notes",
  SUB_WORK_ORDER_NOTES: "/WorkOrders/SubWorkOrders/Notes",
  SUB_WORK_ORDER_TECHNICIANS: "/WorkOrders/SubWorkOrders/Technicians",
  SUB_WORK_ORDER_TECHNICIANS_SETSTATUS: "/WorkOrders/SubWorkOrders/Technicians/SetStatus",
  SUB_WORK_ORDER_VEHICLES: "/WorkOrders/SubWorkOrders/Vehicles",
  SUB_WO_EXPENSES: "/WorkOrders/SubWorkOrders/Expenses",
  WORK_ORDERS: "/WorkOrders",
  WORK_ORDERS_NOTES: "/WorkOrders/Notes",
  WORK_ORDERS_CANCEL: "/WorkOrders/Cancel",
  WORK_ORDERS_UnComplete: "/WorkOrders/UnComplete",
  WORK_ORDERS_SIGNATURE: "/WorkOrders/Signature",
  WORK_ORDERS_COMPLETE: "/WorkOrders/Complete",
  CALENDAR: "/Calendar",
  WORK_ORDERS_TIMERS: "TimeTracking/Timers",
  OFFICE_TIMERS: "TimeTracking",
  REPORTS_TIMECARD: "Reports/Timecard",
  VENDORS: "/Vendors",

  ADMIN_TENANTS: "Tenants",
  ADMIN_FEATURES: "Features/available",
  ADMIN_SHARED_CONFIGS: "Features/sharedconfigs",
  ADMIN_FEATURES_ACTIVE: "Features/active",
  ADMIN_SHARED_CONFIGS_REASSIGN: "Features/sharedconfigs/reassign",
  ADMIN_CONFIG: "Features/tenant/{featureid}/config",
  ADMIN_ROLES_WITH_PERMISSIONS: "Roles",
  ADMIN_ROLE: "Roles/{id}",
  ADMIN_ROLES_PERMISSIONS: "Roles/permissions",
  ADMIN_ROLE_PERMISSIONS: "Roles/{id}/permissions",
  NOTIFICATION_TEMPLATES_DESCRIPTORS: "/Settings/tenant/notifications/templates/descriptors",
  NOTIFICATION_TEMPLATE_DETAIL: "/Settings/tenant/notifications/templates/{id}",
  NOTIFICATION_TEMPLATE_UPDATE: "/Settings/tenant/notifications/templates",
};

const defaultFilter = "isDeleted eq false";
const userByTechnicianFilter = "isActive eq true and Roles/any(role: role eq 'Technician')";
const userByTechnicianOnlyCanDoFilter =
  "isActive eq true and rolePermissions/any(p: p eq 'WorkOrder.Execute')";

export { API, defaultFilter, userByTechnicianFilter, userByTechnicianOnlyCanDoFilter };
